import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { riskLevelLabel } from '@/const/label'

import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'
import { RiskBadge } from '@/components/shared/risk-badge/risk-badge'
import type { DisplayRisk } from '@/components/shared/risk-badge/types'

import { INHERENT_RISK_ICON_LABEL } from './labels'

type InherentRiskIconProps = {
  risk: DisplayRisk
  className?: string
  showTooltip?: boolean
}

export const InherentRiskIcon = ({
  risk: { riskLevel, isEstimated },
  className,
  showTooltip = true,
}: InherentRiskIconProps) => {
  const label = riskLevelLabel[riskLevel]
  if (riskLevel === RiskLevel.UNSPECIFIED || !label) return null

  const trigger = (
    <RiskBadge
      riskLevel={riskLevel}
      size='icon'
      className={className}
      variant={isEstimated ? 'estimated' : 'default'}
    />
  )

  return (
    <Tooltip trigger={trigger} tooltipDisabled={!showTooltip}>
      <div className='capitalize'>
        {isEstimated
          ? INHERENT_RISK_ICON_LABEL.ESTIMATED_INHERENT_RISK
          : INHERENT_RISK_ICON_LABEL.INHERENT_RISK}
        : {label}
      </div>
    </Tooltip>
  )
}
